import _ from "lodash";
import { EditTable, EditTableConfig, IEditController, EditTableItem, EditTableSortColumn } from "../../../../shared/components/edit-table/edit-table";
import { WebForm } from "../../../../shared/components/web-form/web-form.objects";
import { TableRenderer, TableRenderType } from "../../../../shared/components/edit-table/table-renderer";
import { MultiselectFilter, MultiselectFilterOptions, FilterTab, FilterDataType } from "../../../../shared/components/filter/filter.objects";
import { TableColumnGroup } from "../../../../shared/scripts/table-column-visibility";
import { JsonItem } from "../../../../shared/entities/pick-list/pick-list.entities";
import { plainToClass } from "class-transformer";
import { CppForm } from "../../../../shared/entities/cpp-form/cpp-form";

export class CppTableController {
    tableConfig: EditTableConfig;
    editTable: EditTable;
    tableRenderer: TableRenderer;

    pickLists: JsonItem[];
    formList: CppForm[];
    editList: CppForm[];

    targetId: string; // Where the component table should be placed

    // Might Move to Separate Class
    getRoute: string = "/api/cpp-form";

    constructor(targetId: string, editController: IEditController) {
        this.targetId = targetId;

        // Table Configuration
        this.tableConfig = {
            tableId: "clear-study",
            tableVarName: "tableController.editTable",
            propertyIdName: "Id",
            itemDisplayName: "CPP Proposals",
            isEditable: true,
            isMultiselect: false,
            editController: editController,
            tableColumnGroups: [
                new TableColumnGroup("General", true, [], "general"),
                //new TableColumnGroup("Details", false, [], "details"),
            ],
            filterTabs: [
                new FilterTab("general-cpp-tab", "General", "General", [
                    new MultiselectFilter("status-filter", "Status", "StatusId", new MultiselectFilterOptions(true, "pl-cpp-status", FilterDataType.Number))
                ]) 
            ],
            columns: [
                {
                    data: null, title: "ID", className: "text-left font-size12 nowrap", render: (data: CppForm, type) => {
                        if (type == "display") {
                            return this.renderID(data)
                        }
                        else {
                            return data.Id
                        }
                    }
                },
                { data: "AppUserId", title: "Submitter", className: "general text-left font-size12 table-column-md", render: (data) => { return this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-user") } },
                { data: "StatusId", title: "Status", className: "general text-left font-size12 nowrap", render: (data) => { return this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-cpp-status") } },
                { data: "ProjectTitle", title: "Title", className: "general text-left font-size12 nowrap", render: (data) => { return this.tableRenderer.renderLargeText(data, 50) } },
                { data: "LeadHubId", title: "Lead Hub", className: "general text-left font-size12 table-column-md lh-normal", render: (data) => { return this.tableRenderer.renderDisplay(data, TableRenderType.Number, "pl-hub") } },
                { data: "CollaboratingHubIds", title: "Collaborating Hubs", className: "general text-left font-size12 table-column-md lh-normal", render: (data) => { return this.tableRenderer.renderDisplay(data, TableRenderType.PipePathSeparatedIds, "pl-hub", "<hr class='my-1' />") } }
            ],
            sortOrder: [
                new EditTableSortColumn(0, 'desc')
            ]
        }

        this.editTable = new EditTable(this.tableConfig);
    }

    private renderID(form: CppForm): string {
        let idStr = form.Id.toString();
        let threeDigitString = idStr.padStart(3, "0");

        return `P${threeDigitString}`;
    }

    async initialize(): Promise<void> {
        // Generate HTML
        let html = this.editTable.generateHtml();
        $(`#${this.targetId}`).empty().html(html);

        let result: any[] = await this.getForms();

        this.formList = [];
        this.editList = [];
        this.pickLists = [];
        if (result["items"]) {
            this.formList = plainToClass(CppForm, <CppForm[]>result["items"])
        }
        if (result["pickLists"]) {
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>result["pickLists"]);
        }
        if (result["editItems"]) {
            this.editList = plainToClass(CppForm, <CppForm[]>result["editItems"])
        }

        this.tableRenderer = new TableRenderer(this.pickLists);

        this.editTable.initialize(this.formList, this.pickLists);
        setTimeout(() => this.editTable.resizeTable(), 100);
    }


    private async getForms(): Promise<any[]> {
        let route = `${this.getRoute}`;

        let result: any;
        try {
            result = await $.ajax(route, {
                method: "GET",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                cache: false
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}

export class CppScientificReviewController {
    cppTable: CppTableController;
    postRoute: string = "/api/cpp-form/update-status-so";

    constructor(cppTable: CppTableController) {
        this.cppTable = cppTable;
    }

    async saveItems(items: any[], isAdd: boolean): Promise<void> {
        try {
            // Remove the EditTable properties
            let updatedItems = [];
            items.forEach(item => {
                let newItem = _.omit(item, ['IsSelected', 'SelectorDisplay']);
                updatedItems.push(newItem);
            });


            // update DB
            await $.ajax(this.postRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: JSON.stringify(updatedItems),
                contentType: "application/json"
            });

            // initialize Table
            await this.cppTable.initialize();
        }
        catch (error) {
            console.log(error);
            alert("An error has occurred while saving. Please refresh the page and try again.");
        }
    }

    getEditMenu(): string {
        return "";
    }
}

export class CppProgramReviewController {
    cppTable: CppTableController;
    postRoute: string = "/api/cpp-form/update-status-po";

    constructor(cppTable: CppTableController) {
        this.cppTable = cppTable;
    }

    async saveItems(items: any[], isAdd: boolean): Promise<void> {
        try {
            // Remove the EditTable properties
            let updatedItems = [];
            items.forEach(item => {
                let newItem = _.omit(item, ['IsSelected', 'SelectorDisplay']);
                updatedItems.push(newItem);
            });

            // update DB
            await $.ajax(this.postRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: JSON.stringify(updatedItems),
                contentType: "application/json"
            });

            // initialize Table
            await this.cppTable.initialize();
        }
        catch (error) {
            console.log(error);
            alert("An error has occurred while saving. Please refresh the page and try again.");
        }
    }

    getEditMenu(): string {
        return "";
    }
}

export class CppAdminController {
    cppTable: CppTableController;
    postRoute: string = "/api/cpp-form/update-status-admin";

    constructor(cppTable: CppTableController) {
        this.cppTable = cppTable;
    }

    async saveItems(items: any[], isAdd: boolean): Promise<void> {
        try {
            // Remove the EditTable properties
            let updatedItems = [];
            items.forEach(item => {
                let newItem = _.omit(item, ['IsSelected', 'SelectorDisplay']);
                updatedItems.push(newItem);
            });

            // update DB
            await $.ajax(this.postRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: JSON.stringify(updatedItems),
                contentType: "application/json"
            });

            // initialize Table
            await this.cppTable.initialize();
        }
        catch (error) {
            console.log(error);
            alert("An error has occurred while saving. Please refresh the page and try again.");
        }
    }

    getEditMenu(): string {
        return "";
    }
}